import { render, staticRenderFns } from "./PaletteCreate.vue?vue&type=template&id=70583736"
import script from "./PaletteCreate.vue?vue&type=script&lang=js"
export * from "./PaletteCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports